module.exports = __webpack_public_path__ + "assets/img/biaoji.40a2af4b.svg";